import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Anchor from './atoms/anchor'; // Support react-router links
// https://github.com/rexxars/react-markdown/issues/29#issuecomment-231556543

var LinkRenderer = function LinkRenderer(_ref) {
  var href = _ref.href,
      children = _ref.children;
  return href.match(/^\//) ? React.createElement(Link, {
    to: href
  }, children) : React.createElement(Anchor, {
    href: href
  }, children);
};

LinkRenderer.defaultProps = {
  href: '',
  children: undefined
};
export default LinkRenderer;
//# sourceMappingURL=link-renderer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/paragraph/es/link-renderer.js
// module id = 237
// module chunks = 0